import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import MyInput from '../../components/ui/MyInput';
import './extra.css';
import MyTextarea from '../../components/ui/MyTextarea';
import PrimaryButton from '../../components/ui/PrimaryButton';
import MyUploadMediaInput from '../../components/ui/MyUploadMediaInput';
import SelectRadio from '../../components/ui/SelectRadio';
import MarketingPhone from '../../components/ui/MarketingPhone';
import { RadioGroup, Radio } from '@nextui-org/react';
import MyDatePicker from '../../components/ui/MyDatePicker';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import LayeredDashboard from '../LayeredDashboard';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import { Calendar } from 'primereact/calendar';
import { useDispatch } from 'react-redux';
import CreateAction from '../../components/operational/createAction';
import systemSlice from '../../redux/systemSlice';
import allTabs from '../DashboardTabs';
import LanguageSelector from '../../components/ui/System/LanguageSelector';
import countryCodes from '../../utils/countryCodes.json';
import SecondaryButton from '../../components/ui/SecondaryButton';

const countryOptions = countryCodes?.map(countryCode => {
  return { code: countryCode.iso2, name: countryCode.language, emoji: countryCode.emoji };
});
const turkishCountryCode = countryOptions.find(countryOption => countryOption.code === 'tr');

const tags = {
  header: ['{{firstName}}', '{{lastName}}'],
  description: ['{{firstName}}', '{{lastName}}'],
};

function splitAndWrapText(text, tags) {
  // Create a regular expression from the tags
  const regex = new RegExp(tags.join('|'), 'g');
  // Split the text by the tags and wrap each tag with a span
  return text
    .split(regex)
    .reduce((acc, part, index, array) => {
      acc.push(part);
      if (index < array.length - 1) {
        const match = text.match(regex)[index];
        acc.push(
          `<span contenteditable='false' style='background-color: #edf2f7;font-size: 12px;color: #4a5568;border-radius: 0.375rem;padding:0.5rem;'>${match}</span>`,
        );
      }
      return acc;
    }, [])
    .join('');
}

const AbondonedCartNotification = ({
  tab,
  activeIndex,
  setIsActive,
  setSelectedNotifications,
  selectedNotifications,
  languageOptions,
  setLanguageOption,
}) => {
  const navigate = useNavigate();
  const headerInputRef = useRef();
  const descriptionInputRef = useRef();
  useEffect(() => {
    if (headerInputRef.current) {
      headerInputRef.current.innerHTML = notificationHeader;
    }
    if (descriptionInputRef.current) {
      descriptionInputRef.current.innerHTML = notificationHeader;
    }
  }, []);

  const [notificationHeader, setNotificationHeader] = useState('');
  const [notificationDescription, setNotificationDescription] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [currentNotifications, setCurrentNotifications] = useState();
  const updateSelectedLanguage = (key, value) => {
    setCurrentNotifications(state => {
      const newState = [...state];
      const activeElement = newState?.find(element => element?.language === selectedLanguage?.code);
      activeElement[key] = value;
      return newState;
    });
  };

  useEffect(() => {
    const activeElement = currentNotifications?.find(element => element?.language === selectedLanguage?.code);
    const header = activeElement?.title || '';
    const description = activeElement?.body || '';
    setNotificationHeader(header);

    if (headerInputRef.current) {
      const splitted = splitAndWrapText(header, tags.header);
      headerInputRef.current.innerHTML = splitted;
    }

    setNotificationDescription(description);

    if (descriptionInputRef.current) {
      const splitted = splitAndWrapText(description, tags.description);
      descriptionInputRef.current.innerHTML = splitted;
    }
  }, [selectedLanguage]);

  useEffect(() => {
    const activeNotifications = selectedNotifications?.[activeIndex];
    const verifiedActiveNotifications = activeNotifications?.map(activeNotification => {
      const activeLanguage = languageOptions?.find(option => option.code === activeNotification?.language);
      if (!activeLanguage) return { ...activeNotification, language: languageOptions?.[0]?.code };
      return activeNotification;
    });
    const activeElement = verifiedActiveNotifications?.[0];
    const activeLanguage = languageOptions?.find(option => option.code === activeElement?.language);
    setSelectedLanguage(activeLanguage || languageOptions?.[0]);
    setCurrentNotifications(verifiedActiveNotifications ? structuredClone(verifiedActiveNotifications) : null);
    console.log(verifiedActiveNotifications);
  }, [activeIndex]);
  console.log(currentNotifications);
  const setText = (type, text, setRef) => {
    if (type === 'header') {
      if (setRef ? (notificationHeader?.length || 0) + text?.length > 80 : text?.length > 80) return;
      setRef
        ? updateSelectedLanguage('title', (notificationHeader || '') + text)
        : updateSelectedLanguage('title', text);
      setRef ? setNotificationHeader(state => (state || '') + text) : setNotificationHeader(text);
      setRef &&
        (headerInputRef.current.innerHTML +=
          "<span contenteditable='false' style='background-color: #edf2f7;font-size: 12px;color: #4a5568;border-radius: 0.375rem;padding:0.5rem;'>" +
          text +
          '</span>');
      return;
    }

    if (setRef ? (notificationDescription?.length || 0) + text?.length > 80 : text?.length > 80) return;
    setRef
      ? updateSelectedLanguage('body', (notificationDescription || '') + text)
      : updateSelectedLanguage('body', text);
    setRef ? setNotificationDescription(state => (state || '') + text) : setNotificationDescription(text);
    setRef &&
      (descriptionInputRef.current.innerHTML +=
        "<span contenteditable='false' style='background-color: #edf2f7;font-size: 12px;color: #4a5568;border-radius: 0.375rem;padding:0.5rem;'>" +
        text +
        '</span>');
    return;
  };

  function isTextRemoveKey(event) {
    const { keyCode, ctrlKey, metaKey } = event;

    // Check if keyCode matches any of the text remove actions
    if (
      keyCode === 8 || // Backspace
      keyCode === 46 || // Delete
      (keyCode === 88 && ctrlKey) || // Ctrl+X (Cut)
      (keyCode === 88 && metaKey) // Cmd+X (Cut on macOS)
    ) {
      return true;
    }

    return false;
  }

  return (
    <>
      <LayeredDashboardHeader
        tab={tab}
        setIsActive={setIsActive}
        onSave={() => {
          setSelectedNotifications(state => {
            const prevState = [...state];

            prevState[activeIndex] = currentNotifications;
            return prevState;
          });
          setIsActive(false);
        }}
        onLeave={() => {
          setIsActive(false);
        }}
      ></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex justify-center items-center">
            <div className="bg-white p-[20px] max-w-[1120px]  w-[100%] rounded-[10px]">
              <div className="flex flex-col-reverse lg:flex-row">
                <div className="border-r mt-[30px] lg:mt-[0px] border-[#F8F8F8] w-[100%] lg:w-[50%]">
                  <div className="lg:pr-[20px]">
                    <div className="addCategoryInputs">
                      <div className="flex flex-row gap-[15px]">
                        {languageOptions?.map((languageOption, index) => {
                          if (languageOption?.code === selectedLanguage?.code)
                            return (
                              <PrimaryButton
                                value={languageOption?.name}
                                onClick={() => {
                                  setSelectedLanguage(languageOptions[index]);
                                }}
                              ></PrimaryButton>
                            );
                          return (
                            <SecondaryButton
                              value={languageOption.name}
                              onClick={() => {
                                setSelectedLanguage(languageOptions[index]);
                              }}
                            ></SecondaryButton>
                          );
                        })}
                      </div>
                      <span className="text-[#5E5873] font-medium text-[18px] mb-[20px] block">Bildirim Ayarları</span>
                      <div className=" flex flex-col mb-[30px]">
                        {/* <div className='flex flex-row gap-[5px]'>
                                                    {tags.header.map((tag) => {
                                                        return <span onClick={() => { setText("header", tag, true) }} className='bg-gray-200 text-[12px] text-gray-700 hover:text-[#7059ef] cursor-pointer rounded-md p-2'>{tag}</span>
                                                    })}
                                                </div> */}
                        <span className="text-[#5E5873] mb-[5px] block font-medium text-[14px] ">
                          Bildirim Başlığı <span className="text-[#7059EF]">*</span>
                        </span>
                        <div className="p-3 w-full border-1 rounded-md relative">
                          <div
                            onKeyDown={e => {
                              if (notificationHeader?.length >= 80) {
                                const isRemove = isTextRemoveKey(e);
                                !isRemove && e.preventDefault();
                              }
                            }}
                            ref={headerInputRef}
                            className=" w-full outline-0 text-[14px]"
                            contentEditable="plaintext-only"
                            onInput={e => setText('header', e.currentTarget.innerText)}
                          ></div>
                          <div className="w-full text-end text-gray-700 text-[12px]">
                            {notificationHeader?.length || 0}/80{' '}
                          </div>
                        </div>
                      </div>
                      <div className=" flex flex-col mb-[30px]">
                        {/* <div className='flex flex-row gap-[5px]'>
                                                    {tags.description.map((tag) => {
                                                        return <span onClick={() => { setText("description", tag, true) }} className='bg-gray-200 text-[12px] text-gray-700 hover:text-[#7059ef] cursor-pointer rounded-md p-2'>{tag}</span>
                                                    })}
                                                </div> */}
                        <span className="text-[#5E5873] mb-[5px] block font-medium text-[14px] ">
                          Bildirim Alt Metni <span className="text-[#7059EF]">*</span>
                        </span>
                        <div className="p-3 w-full border-1 rounded-md relative">
                          <div
                            onKeyDown={e => {
                              if (notificationDescription?.length >= 80) {
                                const isRemove = isTextRemoveKey(e);
                                !isRemove && e.preventDefault();
                              }
                            }}
                            ref={descriptionInputRef}
                            className="w-full outline-0 text-[14px]"
                            contentEditable="plaintext-only"
                            onInput={e => {
                              setText('description', e.currentTarget.innerText);
                            }}
                          ></div>
                          <div className="w-full text-end text-gray-700 text-[12px]">
                            {notificationDescription?.length || 0}/80{' '}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" w-[100%] lg:w-[50%]">
                  <div className="lg:pl-[20px]">
                    <span className="text-[#5E5873] font-medium text-[18px] mb-[20px] block">Önizleme</span>
                    <div style={{ wordWrap: 'break-word' }}>
                      <MarketingPhone
                        notificationHeader={notificationHeader}
                        notificationDescription={notificationDescription}
                        phoneType={1}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AbondonedCartNotification;
